module.exports = __webpack_public_path__ + "img/20-white.0bce5d9c.svg";